import {Col, FormGroup, Label, Row, Alert} from "reactstrap";
import React, {Fragment, useRef} from "react";
import Select from "react-select";
import {useDispatch, useSelector} from "react-redux";

const buildInPostTrackingUrl = (number) => `https://inpost.co.uk/tracking/result?parcel_code=${number || ''}`;
// WHY: APC uses one static tracking page for every parcel, so (unlike InPost) it is not rebuilt when the tracking number changes
const APC_TRACKING_URL = 'https://apcchoice.apc-overnight.com/';

const TrackingForm = (props) => {
    const {errors,register, orderState, setValue, getValues, trigger, errorMessage}=props;

    const userState =  useSelector(({authReducer}) => authReducer.data);

    return (
        <Fragment>
                { errorMessage && (
                <Alert color="secondary dark" className="mb-4" >
                    <p>{errorMessage}</p>
                </Alert>
                )}

                <Row>
                    {/* <Col md={6}>
                        <FormGroup>
                            <Label className="form-label">Tracking Name<span style={{color:"red"}}>*</span></Label>
                            <input name="deliver_partner" type="text" className={`form-control ${errors.deliver_partner ? 'is-invalid' : ''}`} placeholder="DHL" {...register('deliver_partner')}  />
                            <div className="invalid-feedback">{errors.deliver_partner?.message}</div>
                        </FormGroup>
                    </Col> */}
                    <Col md={6}>
                        <Label for="selectOption">Select Delivery Partner</Label>
                            <Select 
                                placeholder="Select Partners"
                                type="select"
                                name="deliver_partner"
                                value={getValues('deliver_partner')}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                                {...register("deliver_partner")}
                                isClearable
                                options={orderState.deliverPartner}
                                onChange={(e) => {
                                    setValue('deliver_partner',e);
                                    if (e && e.name === 'InPost') {
                                        setValue('tracking_url', buildInPostTrackingUrl(getValues('tracking_number')));
                                        trigger('tracking_url');
                                    } else if (e && e.name === 'APC') {
                                        setValue('tracking_url', APC_TRACKING_URL);
                                        trigger('tracking_url');
                                    }
                                    trigger('deliver_partner');
                                }}
                                className={` ${errors.deliver_partner ? 'is-invalid' : ''}`}
                            />
                            <div className="invalid-feedback">{errors.deliver_partner?.message}</div>
                        
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Label className="form-label">Tracking ID <span style={{color:"red"}}>*</span></Label>
                            <input name="tracking_id" type="text" className={`form-control ${errors.tracking_id ? 'is-invalid' : ''}`} placeholder="2164116410" {...register('tracking_id')} />
                            <div className="invalid-feedback">{errors.tracking_id?.message}</div>
                        </FormGroup>
                    </Col>
                    <Col md={12}>
                        <FormGroup>
                            <Label className="form-label">Tracking Number <span style={{color:"red"}}>*</span></Label>
                            <input name="tracking_number" type="text" className={`form-control ${errors.tracking_number ? 'is-invalid' : ''}`} placeholder="AD30964010288" {...register('tracking_number', {
                                onChange: (e) => {
                                    if (getValues('deliver_partner')?.name === 'InPost') {
                                        setValue('tracking_url', buildInPostTrackingUrl(e.target.value));
                                        trigger('tracking_url');
                                    }
                                }
                            })} />
                            <div className="invalid-feedback">{errors.tracking_number?.message}</div>
                        </FormGroup>
                    </Col>
                    <Col md={12}>
                        <FormGroup>
                            <Label className="form-label">Tracking URL <span style={{color:"red"}}>*</span></Label>
                            <input name="tracking_url" type="text" className={`form-control ${errors.tracking_url ? 'is-invalid' : ''}`} placeholder="https://www.dhl.co.uk/url" {...register('tracking_url')} />
                            <div className="invalid-feedback">{errors.tracking_url?.message}</div>
                        </FormGroup>
                    </Col>

                    {userState.user.is_primary_seller ? 
                    <>
                        {(getValues('status') != 1) ? '' : 
                        <Col md={12}>
                            <FormGroup className="form-check">
                                <input type="checkbox" className="form-check-input" id="tackingIsUpdate" {...register('only_update')} />
                                <Label className="form-check-label" for="tackingIsUpdate">Update tracking details on Shopify</Label>
                            </FormGroup>
                        </Col>
                        }
                    </> 
                    : 
                    <></>
                    }
                </Row>
        </Fragment>
    );
};

export default TrackingForm;